var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#E10092"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8303 17.639L16.3514 21.2657C16.4669 21.5383 16.6806 21.7554 16.9485 21.8744L21.2012 23.7351C21.4299 23.8356 21.4299 24.1648 21.2012 24.2653L16.9485 26.1271C16.6806 26.2449 16.4669 26.4632 16.3514 26.7358L14.8303 30.3625C14.4687 31.4355 15.5637 32.4265 16.6101 31.9726L32.548 25.0622C33.4708 24.6626 33.4708 23.3389 32.548 22.9393L16.6101 16.0278C15.5637 15.575 14.4687 16.5649 14.8303 17.639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/SendButton.144b0edc1ea47fb1c8491686cc36ecf3.svg";
export { ForwardRef as ReactComponent };